import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './_loaders.module.sass';

const PageLoader = () => (
    <CircularProgress size={100} className={styles.pageLoader} />
);

export default PageLoader;
